import { appsApi } from '../api/apps.api';
import { useSelectedApp } from '../context/SelectedApp';

/**
 * Selector de app del header. Es el único lugar donde se elige la app: las
 * pantallas la leen del contexto en vez de pedirla cada una por su cuenta.
 *
 * "Todas las apps" es una opción válida y no un estado de error: los listados
 * globales (notificaciones, DLQ, métricas) tienen sentido así. Lo que no se
 * puede hacer sin app elegida es escribir, y cada pantalla lo dice donde
 * corresponde.
 */
export function GlobalAppSelector() {
  const { appId, setAppId } = useSelectedApp();
  const { data: apps, loading } = appsApi.useList();

  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="hidden text-muted-foreground sm:inline">App</span>
      <select
        aria-label="App seleccionada"
        value={appId}
        onChange={(e) => setAppId(e.target.value)}
        disabled={loading}
        className="h-9 max-w-[12rem] rounded-md border border-input bg-background px-2 text-sm"
      >
        <option value="">{loading ? 'Cargando…' : 'Todas las apps'}</option>
        {(apps ?? []).map((a) => (
          <option key={a.id} value={a.id}>
            {a.name}
          </option>
        ))}
      </select>
    </label>
  );
}
